<template>
    <div class="bg-gray-800 hidden lg:block">
        <div class="mx-auto flex h-10 max-w-7xl items-center justify-end px-4 sm:px-6 lg:px-8">
            <div class="flex items-center space-x-6">
                <div class="text-xs text-gray-100">
                    Diese Seite gehört zum Evangelischen Jugendwerk in Württemberg
                    <img
                        src="/ejwLogoSmall.png"
                        alt="EJW Logo"
                        class="inline h-4 ml-2">
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">

</script>